import { render, staticRenderFns } from "./transferEvent.vue?vue&type=template&id=0ff3f097&"
import script from "./transferEvent.vue?vue&type=script&lang=js&"
export * from "./transferEvent.vue?vue&type=script&lang=js&"
import style0 from "./transferEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports